<template>
  <div>
    <div class="is-flex is-justify-content-space-between">
      <label class="label">Contact Person</label>
      <button class="button is-small is-primary is-light"
        :class="`is-light-btn-${$theme.name}`"
        @click="addNewContact"
        :disabled="!$userInfo.isSystemAccount">
        <span class="mso mso-24px">add</span>
      </button>

      <ContactModal v-if="companyContact"
        :active="showContactModal"
        :contact="companyContact"
        @close="showContactModal=false"
        @save="addContact" />
    </div>
    <div v-if="contacts && contacts?.length > 0">
      <div class="field columns mb-0">
        <div class="column is-half">
          <label class="label has-text-weight-normal">First Name</label>
        </div>
        <div class="column is-half">
          <label class="label has-text-weight-normal">Last Name</label>
        </div>
      </div>
      <div v-for="(contact, index) in contacts"
        :key="index"
        class="field columns is-flex is-align-items-center">
        <div class="column is-half">
          <div class="control">
            <input class="input"
              type="text"
              placeholder="First Name"
              v-model="contact.firstName"
              :disabled="!$userInfo.isSystemAccount"
              :class="{ 'is-danger' : $v.contacts.$each[index].firstName.$error }"
              @input="$v.contacts.$each[index].$touch()">
            <span class="help is-danger"
              v-if="!$v.contacts.$each[index].firstName.required">First Name is required
            </span>
          </div>
        </div>
        <div class="field has-addons column is-half">
          <div class="control is-expanded">
            <input class="input"
              type="text"
              placeholder="Last Name"
              v-model="contact.lastName"
              :disabled="!$userInfo.isSystemAccount"
              :class="{ 'is-danger' : $v.contacts.$each[index].lastName.$error }"
              @input="$v.contacts.$each[index].lastName.$touch()">
            <span class="help is-danger"
              v-if="!$v.contacts.$each[index].lastName.required">Last Name is required
            </span>
          </div>
          <div class="control">
            <button class="button has-text-gold"
              @click="setDefault(contact, 'contacts')"
              :disabled="!$userInfo.isSystemAccount">
              <span class="icon">
                <span class="mso mso-24px"
                  :class="[contact.isDefault ? 'mso-fill' : '']">
                  star
                </span>
              </span>
            </button>
          </div>
          <div class="control">
            <button class="button has-text-primary"
              @click="editContact(contact, index)">
              <span class="icon">
                <span class="mso mso-24px">
                  edit
                </span>
              </span>
            </button>
          </div>
          <div class="control">
            <button class="button has-text-danger"
              @click="removeContact(contact)"
              :disabled="!$userInfo.isSystemAccount">
              <span class="icon">
                <span class="mso mso-24px">remove</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else
      class="label has-text-weight-normal ml-1">No Contacts</div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ContactModel } from '../../../classes/viewmodels'
import Guid from '../../../components/Guid'
import ContactService from '../../contact/ContactService'
import ContactModal from './ContactModal.vue'

export default {
  name: 'CompanyContact',
  components: {
    ContactModal
  },
  props: {
    contacts: {
      type: Array,
      default: () => []
    },
    companyId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      companyContact: null,
      showContactModal: false,
      editingContactIndex: null
    }
  },
  computed: {},
  mounted() {
    this.$v.$touch()
  },
  methods: {
    addContact(contact) {
      if (this.editingContactIndex !== null) {
        // this.$set(this.contacts[this.editingContactIndex], 'contact', contact)
        this.$set(this.contacts, this.editingContactIndex, contact)
        this.editingContactIndex = null
        contact.id = contact.contactId
        this.updateContacts(contact)
      } else {
        this.$emit('addContact', contact)
      }
      this.showContactModal = false
    },
    editContact(contact, index) {
      this.companyContact = JSON.parse(JSON.stringify(contact))
      this.editingContactIndex = index
      this.showContactModal = true
    },
    removeContact(contact) {
      this.$emit('removeContact', contact)
    },
    setDefault(contact) {
      this.$emit('setDefault', contact, 'contacts')
      if (Array.isArray(this.contacts)) {
        this.contacts.forEach((c) => {
          if (c === contact) {
            if (Array.isArray(c.emails)) {
              c.emails.forEach((email, idx) => {
                email.isDefault = idx === 0
              })
            }
            if (Array.isArray(c.addresses)) {
              c.addresses.forEach((address, idx) => {
                address.isDefault = idx === 0
              })
            }
            if (Array.isArray(c.phones)) {
              c.phones.forEach((phone, idx) => {
                phone.isDefault = idx === 0
              })
            }
          } else if (c) {
            if (Array.isArray(c.emails)) {
              c.emails.forEach((email) => {
                email.isDefault = false
              })
            }
            if (Array.isArray(c.addresses)) {
              c.addresses.forEach((address) => {
                address.isDefault = false
              })
            }
            if (Array.isArray(c.phones)) {
              c.phones.forEach((phone) => {
                phone.isDefault = false
              })
            }
          }
          c.id = c.contactId
          this.updateContacts(c)
        })
      }
    },

    addNewContact() {
      ContactService.getNewAssetContact('Company', Guid.newGuid()).then((response) => {
        const newContact = response.data
        var newMap = new ContactModel(newContact.id, newContact.firstName, newContact.lastName)
        newMap.isNew = true
        if (this.$parent) {
          if (Array.isArray(this.$parent.companyDetails.assetAddresses)) {
            const defaultAddress = this.$parent.companyDetails.assetAddresses.find((a) => a.isDefault)
            if (defaultAddress) {
              newMap.addresses = [JSON.parse(JSON.stringify(defaultAddress))]
              newMap.addresses[0].isDefault = true
              newMap.addresses[0].isNew = true
              newMap.addresses[0].id = Guid.empty()
            }
          }
          if (Array.isArray(this.$parent.companyDetails.assetPhones)) {
            const defaultPhone = this.$parent.companyDetails.assetPhones.find((a) => a.isDefault)
            if (defaultPhone) {
              newMap.phones = [JSON.parse(JSON.stringify(defaultPhone))]
              newMap.phones[0].isDefault = true
              newMap.phones[0].isNew = true
              newMap.phones[0].id = Guid.empty()
            }
          }
          if (Array.isArray(this.$parent.companyDetails.assetEmails)) {
            const defaultEmail = this.$parent.companyDetails.assetEmails.find((a) => a.isDefault)
            if (defaultEmail) {
              newMap.emails = [JSON.parse(JSON.stringify(defaultEmail))]
              newMap.emails[0].isDefault = true
              newMap.emails[0].isNew = true
              newMap.emails[0].id = Guid.empty()
            }
          }
        }

        var anyDefault = this.contacts && this.contacts.find((d) => !d.isDeleted && d.isDefault)
        if (!anyDefault) {
          newMap.isDefault = true
        }
        this.companyContact = newMap
        this.companyContact.companyId = this.companyId
      })
      this.showContactModal = true
    },
    async updateContacts(contact) {
      await ContactService.putContact(contact)
    }
  },
  validations: {
    contacts: {
      $each: {
        firstName: {
          required
        },
        lastName: {
          required
        }
      }
    }
  }
}
</script>

